angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-analytic-factory',
        function ($api, $factory) {
            $api.factory.analytic = $factory;
        },
    ])
    .factory('graph-analytic-factory', [
        'graph-api-client',
        function (client) {
            return {
                statistics: function (id, options) {
                    return client.get([id, 'analytics'], options);
                },
                dates: function (id, accountId, options) {
                    return client.get([id, 'analytics', 'account', accountId, 'dates'], options);
                },
                portfolio: function (id, options) {
                    return client.get([id, 'analytics', 'trades', 'opened'], options);
                },
                history: function (id, accountId, options) {
                    return client.get([id, 'analytics', 'account', accountId, 'trades', 'closed'], options);
                },
                clear: function (id, options) {
                    return client.delete([id, 'analytics', 'trades', 'closed'], options);
                },
                clearByAccount: function (userId, accountId, options) {
                    return client.delete([userId, 'analytics', 'account', accountId, 'trades', 'closed'], options);
                },
                setting: function (id, data, options) {
                    return client.post([id, 'analytics', 'settings'], data, options);
                },
                settings: function (id, options) {
                    return client.get([id, 'analytics', 'settings'], options);
                },
                update: function (id, account, data, options) {
                    return client.post([id, 'analytics', 'account', account], data, options);
                },
                main: function (id, account, options) {
                    return client.post([id, 'analytics', 'account', 'main', account], undefined, options);
                },
                visible: function (id, account, options) {
                    return client.post([id, 'analytics', 'account', 'visible', account], undefined, options);
                },
                invisible: function (id, account, options) {
                    return client.delete([id, 'analytics', 'account', 'invisible', account], undefined, options);
                },
                accounts: function (id, options) {
                    return client.get([id, 'analytics', 'accounts'], options);
                },
                account: function (id, options) {
                    return client.get([id, 'analytics', 'account'], options);
                },
            };
        },
    ]);
